import { SelectField_default } from "./chunk-GREJLR3U.js";
import { Select_Option_default } from "./chunk-4VD35KDM.js";

// src/components/SelectField/index.tsx
var SelectFieldComponent = SelectField_default;
SelectFieldComponent.Option = Select_Option_default;
SelectFieldComponent.Option.displayName = "SelectField.Option";
export { SelectFieldComponent };